/* Poedagar - Black November: brindes por valor do pedido (produtos a 0, nao listados).
   O desconto continua sendo da Shopify; este arquivo so poe e tira os brindes do carrinho. */
(function () {
  var V = {
    box: { product: 15461113004339, def: 67858160320819, name: 'Premium Box' },
    wallet: { product: 15463019643187, def: 67879420723507, name: 'Wallet' },
    roll: { product: 15461113102643, def: 67858160451891, name: 'Leather Watch Roll' }
  };
  var TIERS = [[60, 'box'], [85, 'wallet'], [110, 'roll']];
  var BOX_PAGA = 51837605019955;
  var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
  var busy = false, again = false, last = null, timer = null, fails = 0;
  var nativeFetch = window.fetch.bind(window);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function isGift(i) { return i.product_type === 'Gift'; }
  function post(path, body) {
    return nativeFetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });
  }
  function getCart() { return nativeFetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function fmt(c, cur) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(c / 100); } catch (e) { return (c / 100).toFixed(2); }
  }
  /* redesenha a gaveta do carrinho com o que a loja tem agora */
  function refresh() {
    if (/\/cart(\/|$|\?)/.test(location.pathname)) { location.reload(); return Promise.resolve(); }
    return nativeFetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var doc = new DOMParser().parseFromString(s['cart-drawer'] || '', 'text/html');
      var novo = doc.querySelector('#CartDrawer'), velho = document.querySelector('#CartDrawer');
      if (novo && velho) velho.innerHTML = novo.innerHTML;
      var dv = document.querySelector('cart-drawer');
      var dn = doc.querySelector('cart-drawer');
      if (dv && dn) dv.classList.toggle('is-empty', dn.classList.contains('is-empty'));
      var bolha = document.getElementById('cart-icon-bubble');
      var b = new DOMParser().parseFromString(s['cart-icon-bubble'] || '', 'text/html').querySelector('.shopify-section');
      if (bolha && b) bolha.innerHTML = b.innerHTML;
    }).catch(function () {});
  }

  function sync() {
    if (busy) { again = true; return; }
    if (fails >= 3) return; /* erro de carrinho nunca vira repeticao infinita */
    busy = true;
    var changed = false;
    getCart().then(function (cart) {
      var want = {};
      var pagos = cart.items.filter(function (i) { return !isGift(i); }).length;
      if (!pagos) cart = Object.assign({}, cart, { total_price: 0 });
      TIERS.forEach(function (t) { if (cart.total_price >= t[0] * 100 * rate) want[V[t[1]].product] = t[1]; });
      var updates = {}, have = {};
      cart.items.filter(isGift).forEach(function (i) {
        if (!want[i.product_id] || have[i.product_id]) updates[i.key] = 0;
        else { have[i.product_id] = 1; if (i.quantity !== 1) updates[i.key] = 1; }
      });
      /* caixa paga (upsell da pagina do produto) + caixa de brinde: tira a paga se a faixa continuar valendo */
      cart.items.forEach(function (i) {
        if (i.variant_id === BOX_PAGA && want[V.box.product] && cart.total_price - i.final_line_price >= TIERS[0][0] * 100 * rate) updates[i.key] = 0;
      });
      var add = [];
      Object.keys(want).forEach(function (p) { if (!have[p]) add.push({ id: V[want[p]].def, quantity: 1 }); });
      var chain = Promise.resolve();
      if (Object.keys(updates).length) { changed = true; chain = chain.then(function () { return post('cart/update.js', { updates: updates }); }); }
      if (add.length) { changed = true; chain = chain.then(function () { return post('cart/add.js', { items: add }); }); }
      return chain.then(function () { return changed ? getCart() : cart; });
    }).then(function (cart) {
      last = cart; fails = 0;
      if (changed) return refresh().then(paint);
      paint();
    }).catch(function () { fails++; }).then(function () {
      busy = false;
      if (again) { again = false; sync(); }
    });
  }
  function later() { clearTimeout(timer); timer = setTimeout(sync, 300); }

  function paint() {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    document.querySelectorAll('[data-bn-eur]').forEach(function (el) {
      var n = Math.ceil(parseFloat(el.getAttribute('data-bn-eur')) * rate);
      try {
        var txt = new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(n);
        if (el.textContent !== txt) el.textContent = txt;
      } catch (e) {}
    });
    if (!last) return;
    var total = last.total_price, next = null, done = 0;
    if (!last.items.some(function (i) { return !isGift(i); })) total = 0;
    TIERS.forEach(function (x) { if (total >= x[0] * 100 * rate) done++; else if (!next) next = x; });
    var msg;
    if (!next) msg = 'All 3 free gifts are in your cart';
    else msg = 'Add ' + fmt(next[0] * 100 * rate - total, last.currency) + ' for a free ' + V[next[1]].name;
    var html = '<span class="poe-bn-pg__t">' + msg + '</span><span class="poe-bn-pg__n">' + done + ' of 3 gifts</span><div class="poe-bn-pg__b"><i style="width:' + Math.round(done / 3 * 100) + '%"></i></div>';
    document.querySelectorAll('[data-poe-bn-progress]').forEach(function (el) {
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }

  /* qualquer mudanca de carrinho feita pelo tema dispara a conferencia */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(later, later);
    return p;
  };
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-poe-gift-line]');
    if (!s) return;
    var key = s.getAttribute('data-poe-gift-line'), id = parseInt(s.value, 10), u = {};
    u[key] = 0;
    busy = true;
    post('cart/update.js', { updates: u }).then(function () { return post('cart/add.js', { items: [{ id: id, quantity: 1 }] }); }).then(getCart).then(function (c) { last = c; return refresh(); }).then(function () { paint(); busy = false; }).catch(function () { busy = false; });
  });
  new MutationObserver(function () {
    if (last && document.querySelector('[data-poe-bn-progress]:empty')) paint();
  }).observe(document.documentElement, { childList: true, subtree: true });
  sync(); paint();
})();
